import { render, staticRenderFns } from "./UpsiRemarksBlock.vue?vue&type=template&id=46c80e91"
import script from "./UpsiRemarksBlock.vue?vue&type=script&lang=js"
export * from "./UpsiRemarksBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports